import { render, staticRenderFns } from "./project-details.vue?vue&type=template&id=c7950654&scoped=true&"
import script from "./project-details.vue?vue&type=script&lang=js&"
export * from "./project-details.vue?vue&type=script&lang=js&"
import style0 from "./project-details.vue?vue&type=style&index=0&id=c7950654&lang=scss&scoped=true&"
import style1 from "./project-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7950654",
  null
  
)

export default component.exports